export const checkNotNull = (value) => {
    if (value !== null) {
        return value;
    }
    throw new Error(`Expected value to not be null, but received ${String(value)}`);
};
